import React, { Component } from 'react';


import MainPage from './Components/MainPage'
import 'bootstrap/dist/css/bootstrap.min.css';

class App extends Component {
  render() {
    return <MainPage></MainPage>
  }
}

export default App;
